import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../../ip_api.config')

class Flim_EditMasterDataMin extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.get_masterStandard()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    get_masterStandard = () => {
        console.log('id', this.state.id)
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/getMaster_Datamin'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        roll: val.roll,
                        slit: val.slit,
                        cm2: val.cm2
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => {
                    console.log("arr_save", this.state.arr_save)
                    this.preview_masterStandard()
                })
            })
    }

    preview_masterStandard = () => {
        let arr = []

        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td>{i + 1}</td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="roll" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.roll} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="slit" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.slit} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="cm2" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.cm2} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (index === 'a') {
            if (name === 'roll') {
                this.state.arr_save.map(function (val, i) {
                    val.roll = value
                })
            } else if (name === 'slit') {
                this.state.arr_save.map(function (val, i) {
                    val.slit = value
                })
            } else if (name === 'cm2') {
                this.state.arr_save.map(function (val, i) {
                    val.cm2 = value
                })
            }
        } else if (name === 'roll') {
            this.state.arr_save[index].roll = value
        } else if (name === 'slit') {
            this.state.arr_save[index].slit = value
        } else if (name === 'cm2') {
            this.state.arr_save[index].cm2 = value
        }
        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.preview_masterStandard()
        })
    }

    update_masterStandard = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_Datamin'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/MasterDataMin'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >Edit Master Werehouse</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_masterStandard()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th>ลำดับ</th>
                            <th>roll</th>
                            <th>slit</th>
                            <th>cm2</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="roll" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="slit" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="cm2" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                        </tr>
                        {this.state.previewbom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_EditMasterDataMin